import { render } from "./FooterSection.vue?vue&type=template&id=646d5dcf"
const script = {}

import exportComponent from "/tmp/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__